import { GridElement } from '..'

export const Headline: React.FC<GridElement> = props => {
    return (
        <div className="component-title-container">
            <h2 className="component-title-container__content">{props.value}</h2>
        </div>
    )
}
